import React from "react";
import "./gridInformative.css";
import { Grid, useMediaQuery } from "@material-ui/core";
import { SimpleLoading } from "..";

const Semaforo = (props) => {
  const { dataItem } = props;
  let color

  if (dataItem.statusDocument === "validated") {
    color = "green"
  } else if (dataItem.statusDocument === "loaded") {
    color = "yellow"
  } else {
    color = "red"
  }

  let circleDisplayed = <div className={`semaforo-circle ${color}`}></div>

  return (
    <>
      <div className='semaforo-container' style={{ marginLeft: 20 }}>
        <div className='semaforo-item'>
          {circleDisplayed}
        </div>
      </div>
    </>
  );
};

function GridInformative(props) {
  const {
    dataItems,
  } = props;
  const showHeader = useMediaQuery("(min-width:960px)");

  return (
    <Grid
      container
      xs={12}
      lg={12}
      md={12}
      sm={12}
      es={12}
      className="gridSemaforo"
    >
      {dataItems === 0 && !showHeader ? <SimpleLoading /> :
        <Grid
          container
          spacing={2}
          className="gridSemaforo-headerContainer"
        >
          <Grid item lg={1} className="gridSemaforo-headerColumn">
            <p className="column-title">Estatus</p>
          </Grid>
          <Grid item lg={2} md={2} className="gridSemaforo-headerColumn">
            <p className="column-title">Documento</p>
          </Grid>
          <Grid item lg={2} md={2} className="gridSemaforo-headerColumn">
            <p className="column-title">Registrado por</p>
          </Grid>
          <Grid item lg={2} md={2} className="gridSemaforo-headerColumn">
            <p className="column-title">Fecha de registro</p>
          </Grid>
          <Grid item lg={2} md={2} className="gridSemaforo-headerColumn">
            <p className="column-title">Validado por</p>
          </Grid>
          <Grid item lg={2} md={2} className="gridSemaforo-headerColumn">
            <p className="column-title">Fecha de validación</p>
          </Grid>
          <Grid item lg={2} md={2} className="gridSemaforo-headerColumn">
            <p className="column-title">Fecha de creación</p>
          </Grid>
          <Grid item lg={2} md={2} className="gridSemaforo-headerColumn">
            <p className="column-title">Creado por</p>
          </Grid>
        </Grid>}
      {/* HEADER */}

      {/* BODY */}
      {dataItems.length === 0 && <p style={{ margin: "auto" }}>No hay datos</p>}
      {dataItems.length > 0 &&
        dataItems.map((dataItem) => (
          <Grid container className="gridSemaforo-item" key={dataItem.name}>
            <Grid item lg={1}>
              <Semaforo dataItem={dataItem} />
            </Grid>
            <Grid item lg={2} md={2}>
              <p className="name">{dataItem.name}</p>
            </Grid>
            <Grid item lg={2} md={2}>
              <p className="name">{dataItem.createdBy}</p>
            </Grid>
            <Grid item lg={2} md={2}>
              <p className="name">{dataItem.registrationDate}</p>
            </Grid>
            <Grid item lg={2} md={2}>
              <p className="name">{dataItem.authorizedBy}</p>
            </Grid>
            <Grid item lg={2} md={2}>
              <p className="name">{dataItem.validationDate}</p>
            </Grid>
            {/* <Grid item lg={2} md={2}>
              <p className="name">{dataItem.createdDate}</p>
            </Grid> */}
             {/* <Grid item lg={2} md={2}>
              <p className="name">{dataItem.createdBy}</p>
            </Grid> */}
          </Grid>
        ))}
    </Grid>
  );
}

export default GridInformative;
